import { Expose } from 'class-transformer';

export class SarsCancellationReportDto {
  @Expose()
  hoursCancelled: string;

  @Expose()
  staffCancellation: string;

  @Expose()
  parentCancellation: number;

  @Expose()
  hoursMakeUp: number;

  @Expose()
  rateAmountCancelled: number;

  @Expose()
  rateAmountMakeUp: number;
}
